import { GRID_DIMENSIONS } from "@/utils/constants";
import { themeMaterial, createPart } from "ag-grid-enterprise";

const myCustomStyles = createPart({
  css: `
        .ag-header-cell-label {
            justify-content: center !important;
            display: flex !important;
            align-items: center !important;
            text-align: center !important;
            padding:0px !important;
    		font-size: 12px;

        }
        
        .ag-checkbox-input-wrapper {
            margin-left: 6.5px !important;

        }
        .ag-checkbox-input-wrapper.ag-checked {
            background-color: #00008B !important;
            border-color: #00008B !important;
        }

        .ag-header-icon, .ag-icon-menu {
            display: none !important;
        }

        .ag-cell {
            white-space: normal !important;
            word-wrap: break-word !important;
            line-height: 1.4 !important;
            text-align: center !important;
            border: none !important;
            padding: 0px !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            font-size: 12px !important;
            word-break: break-word !important;
        }

        .ag-button-cell {
            padding: 0px !important;
            text-align: center !important;
            cursor: pointer !important;
        }

        .ag-center-aligned-header {
            text-align: center !important;
        }

        .ag-center-aligned-cell {
            text-align: center !important;
        }

        .ag-header-cell {
            white-space: normal !important;
            word-wrap: break-word !important;
            padding: 2px !important;
            color: black !important;
        }

        .ag-header-cell-group-cell, .ag-header-group-text {
            padding: 2px !important;
            color: black !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
        }

        .ag-header-group-cell-label {
            text-align: center !important;
            justify-content: center !important;
            display: flex !important;
            align-items: center !important;
            width: 100% !important;
            font-size: 12px !important;
        }

        .ag-root-wrapper {
            border-radius: 3px !important;

        .ag-row {
            border-bottom: 1px solid #e0e0e0;
        }

        .ag-cell-wrapper {
            height: auto !important;
            min-height: 32px !important;
        }

        .ag-menu {
            padding: 4px !important;
            background: #ffffff !important;
            border: 1px solid #e0e0e0 !important;
            border-radius: 8px !important;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
            min-width: 180px !important;
        }

        .ag-menu-list {
            padding: 4px !important;
        }

        .ag-menu-option {
            padding: 6px 10px !important;
            border-radius: 2px !important;
            margin: 2px 0 !important;
            font-size: 13px !important;
            color: #333333 !important;
            background: transparent !important;
            transition: all 0.2s ease !important;
        }

        .ag-menu-option:hover {
            background: #f5f5f5 !important;
            color: #00008B !important;
        }

        .ag-menu-option-disabled {
            color: #999999 !important;
            opacity: 0.6 !important;
        }

        .ag-menu-separator {
            border-top: 1px solid #e0e0e0 !important;
            margin: 4px 0 !important;
        }

        .ag-menu .ag-icon {
            color: #666666 !important;
            fill: #666666 !important;
        }

        .info-limit {
            color: #000 !important;
            background-color: #b2e5ed !important;
            font-weight: 600 !important;
        }

        .ag-grid-buttons {
            opacity: 0 !important;
            transition: opacity 0.1s ease-in-out !important;
            display: flex !important;
            width: 100% !important;
            justify-content: space-around !important;
        }

        .ag-row-hover .ag-grid-buttons {
            opacity: 1 !important;
        }


        .ag-row.unclassified-row {
            background-color: #E8C8C8 !important;
        }

        .ag-row.unclassified-row:hover {
            background-color: #E0B0B0 !important;
        }

        .ag-row.unclassified-row.ag-row-selected {
            background-color: #D8A8A8 !important;
        }

        .ag-row.deleted-row {
            background-color: #FFCDD2 !important;
        }

        .ag-row.deleted-row:hover {
            background-color: #F5B7B7 !important;
        }

        .ag-row.deleted-row.ag-row-selected {
            background-color: #EBA0A0 !important;
        }

    `,
});

const createSampleWizardStyles = createPart({
  css: `
        .ag-cell-value {
            border-right: 1px solid #e0e0e0 !important;
        }

        .ag-header-cell-label {
            border-right: 1px solid #e0e0e0 !important;
        }

        .ag-row .ag-cell:last-child .ag-cell-value,
        .ag-header-row .ag-header-cell:last-child .ag-header-cell-label {
            border-right: none !important;
        }
    `,
});

export const mesfTheme = themeMaterial
  .withParams({
    spacing: 1,
    headerFontSize: 12,
    rowHeight: GRID_DIMENSIONS.ROW_HEIGHT,
    headerHeight: GRID_DIMENSIONS.HEADER_HEIGHT,
  })
  .withPart(myCustomStyles);

export const createSampleWizardTheme = mesfTheme.withPart(
  createSampleWizardStyles,
);

export const defaultColDef = {
  flex: 1,
  filter: false,
  floatingFilter: false,
  sortable: true,
  resizable: false,
  editable: false,
  suppressMovable: true,

  cellStyle: {
    textAlign: "center",
    fontSize: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

const baseGridOptions = {
  tooltipShowDelay: 0,
  tooltipHideDelay: 2000,
  domLayout: "normal" as const,
  suppressContextMenu: true,
  suppressMovableColumns: true,
  animateRows: true,
  pagination: false,
  singleClickEdit: false,
};

export const defaultGridOptions = {
  ...baseGridOptions,
  rowSelection: {
    mode: "singleRow" as const,
    enableClickSelection: true,
    checkboxes: false,
  },
};

export const nonSelectableGridOptions = {
  ...baseGridOptions,
  suppressCellFocus: true,
};
